/**
 * User Types Constants
 * 
 * Centralized user type definitions to avoid circular dependencies
 */

export const USER_TYPES = {
  PET_GUARDIAN: 'PET_GUARDIAN',
  VETERINARIAN: 'VETERINARIAN',
  SERVICE_PROVIDER: 'SERVICE_PROVIDER', // Backend name - displayed as "Service Provider" in UI
  // SERVICE_PROVIDER: 'SERVICE_PROVIDER', // Not used - UI shows "Service Provider" but backend uses SERVICE_PROVIDER
  CLINIC_MODERATOR: 'CLINIC_MODERATOR',
  FIRM: 'FIRM',
  ADMIN: 'ADMIN',
  DEV_ADMIN: 'DEV_ADMIN',
  CONTENT_ADMIN: 'CONTENT_ADMIN'
};
